import {Location, NgClass} from "@angular/common";
import {Component, OnDestroy, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {CookieService} from "ngx-cookie-service";
import {Subscription} from "rxjs";
import {environment} from "src/environments/environment";
import {appearSlowlyAnimation} from "./cookie-modal-animation";
import {DeviceDetectService} from "../../services/device-detect.service";

@Component({
    selector: "app-cookie-modal",
    templateUrl: "./cookie-modal.component.html",
    styleUrls: ["./cookie-modal.component.css"],
    animations: [appearSlowlyAnimation],
    imports: [
        TranslateModule,
        NgClass,
    ]
})
export class CookieModalComponent implements OnInit, OnDestroy {

  constructor(
    private cookieService: CookieService,
    private dialogRef: MatDialogRef<CookieModalComponent>,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private deviceDetect: DeviceDetectService,
  ) {
    this.isMobile = deviceDetect.isMobile;
  }

  showModal: boolean;
  shrinkModal: boolean;
  disappear: boolean;
  languages: string[] = environment.languages;
  cookieExpirationTime: number = environment.cookiesExpirationTime;
  selectedLang: string = "et";
  langChangeSub: Subscription;
  isMobile: boolean;

  ngOnInit(): void {
    this.selectedLang = this.translate.currentLang;
    setTimeout(() => {
      this.showModal = true;
    }, 1000);

    this.langChangeSub = this.translate.onLangChange.subscribe((event) => {
      this.selectedLang = event.lang;
    });

    this.location.onUrlChange((url) => {
      if (url.endsWith("privacy")) {
        this.shrinkModal = true;
      } else {
        this.shrinkModal = false;
      }
    });
  }

  onChangeLang(lang) {
    this.translate.use(lang);
  }

  onAccept() {
    //accept cookies, expires in 1.5 years
    this.cookieService.set("cookies_accepted", "true", this.cookieExpirationTime);
    this.disappear = true;
    this.onClose();
    setTimeout(() => {
      this.router.navigate(["/"]);
    }, 400);
  }

  onClose() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 1000);
  }

  ngOnDestroy() {
    this.langChangeSub.unsubscribe();
  }
}
